const $script = require('scriptjs');
const React = require('react');
const AdTag = require('../components/search-results-ad-tag');

(function () {
  const market = window && window.requestContext && window.requestContext.market;
  if (market !== 'en-US') {
    return;
  }
  const searchResultAd = document.getElementById('search-results-ads-tag');
  if (!searchResultAd) {
    return;
  }
  $script('https://securepubads.g.doubleclick.net/tag/js/gpt.js');
  ReactDOM.render(
    React.createElement(AdTag),
    searchResultAd
  );
}());

